import { Component, Input } from "@angular/core";
import { PropertyStatus } from "../../model/property-status";

@Component({
  selector: "phoenix-property-loader",
  templateUrl: "./property-loader.component.html",
  styleUrls: ["./property-loader.component.scss"],
  standalone: false,
})
export class PhoenixPropertyLoaderComponent {
  propertyStatus = PropertyStatus;

  /** Current load status to display. */
  @Input() status: PropertyStatus;

  @Input() errorMessage: string;

  @Input() downloadingMessage: string;
}
